var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"color":"primary","small":"","dense":""},on:{"click":function($event){return _vm.generate(_vm.kodeSoap)}}},[_vm._v(" "+_vm._s(_vm.viewTombol(_vm.kodeSoap))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }